export enum GarageActions {
  ShipCar = "Ship Car",
  ListOnMarket = "List on Market",
  Transfer = "Transfer",
}
